/**
 * Screen navigation — simple toggle между основным экраном Искры и Атласом
 * открытий (и далее новые экраны по мере роста — Книга Уроков, Личная
 * Роща, Магазин гачи и т.д.).
 *
 * JB 2026-05-25: «в атласе открытий думаю должно быть все в разных
 * категориях от открытых эффектов».
 *
 * Не persisted — переключение экрана это runtime UI state, при reload
 * возвращаемся к главному (Spark). Игрок снова откроет Атлас если
 * захочет.
 */
import { create } from 'zustand';

export type AppScreen = 'spark' | 'atlas';

interface NavigationStore {
  readonly current: AppScreen;
  setScreen(screen: AppScreen): void;
  toggle(target: AppScreen): void;
}

export const useNavigationStore = create<NavigationStore>((set, get) => ({
  current: 'spark',
  setScreen(screen) {
    set({ current: screen });
  },
  toggle(target) {
    set({ current: get().current === target ? 'spark' : target });
  },
}));
